<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="未处理" name="未处理">
				<activeWcl ref="wei"></activeWcl>
			</el-tab-pane>
			<el-tab-pane label="已处理" name="已处理">
				<activeYcl ref="yi"></activeYcl>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import activeYcl from "./activeYcl.vue"
	import activeWcl from "./activeWcl.vue"
	export default {
		components: {
			activeYcl,
			activeWcl
			
		},
		data() {
			return {
				activeName: "未处理"
			}
		},
		methods: {
			handleClick(){
				if(this.activeName=="未处理"){
					this.$refs.wei.getAll();
				}else{
					this.$refs.yi.getAll();
				}
			}
		}
	}
</script>

<style>
</style>
